

import { Box, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
const useStyles = makeStyles((theme: Theme) => createStyles({
  Title: {
    display: 'flex',
    flexDirection:'row',
    alignItems:'center',
    paddingLeft:'20px',
    border:'1px solid #d7d4d4',
    borderWidth:'0 0 1px 0',
    background:'#F9F9F9',
    cursor:'pointer'
   
  },
  TitleNoBorder: {
    display: 'flex',
    flexDirection:'row',
    alignItems:'center',
    paddingLeft:'20px',
    borderWidth:'0 0 1px 0',
    background:'#F9F9F9',
   
  },
  left:{

    // width:'3px',
    // height:'29px',
    // background:'red',

  },
  right:{
    color:'black',
    fontWeight:'500',
    fontSize:'18px',
    paddingLeft:'20px',
    paddingTop:'20px',
    paddingBottom:'20px',
  }
  
  
}));

export default function MenuItem ({name, onClick}) {
  const classes = useStyles();

  return (
    <Box className={classes.Title} onClick={()=>{onClick()}}>
      <img className={classes.left} src={'/images/menu.png'}>
      </img>
      <Typography className={classes.right}>
        {name}
      </Typography >
      {/* <Box style={{width:'100%',height:'1px',background:'gray'}}></Box> */}
    </Box>
  );
}

export  function OpenMenuItem ({name, onClick}) {
  const classes = useStyles();

  return (
    <Box className={classes.TitleNoBorder} style={{background:'#f2f2f2'}} onClick={()=>{onClick()}}>
      <img className={classes.left} style={{ transform: 'rotate(90deg)'}} src={'/images/menu.png'}>
      </img>
      <Typography className={classes.right}>
        {name}
      </Typography >
      {/* <Box style={{width:'100%',height:'1px',background:'gray'}}></Box> */}
    </Box>
  );
}